export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-3.ff0da886.png";